import React from 'react';
import PropTypes from 'prop-types';

import { VariantPropType } from 'propTypes/common';

// eslint-disable-next-line import/no-cycle
import Question from '../Question';
import QuestionsSlider from '../QuestionsSlider';

import styles from './styles.module.scss';

const QuestionsList = ({
	contentContainerRef,
	finishTest,
	isSliderLayout,
	isTestFinished,
	isTestCorrect,
	mode,
	questions,
	selectVariant,
	selectedVariants,
	type
}) => {
	const renderQuestion = (question, index, isSubmitted) => (
		<Question
			{...{
				question,
				selectVariant,
				selectedVariants,
				questionNumber: index,
				totalQuestions: questions?.length ?? 0,
				key: `${index}_${question.text}` || question.answer.text,
				isTestFinished,
				interactiveMode: mode,
				interactiveType: type,
				isSubmitted,
				isTestCorrect
			}}
		/>
	);

	return questions ? (
		<ol className={styles.QuestionsList}>
			{isSliderLayout ? (
				<QuestionsSlider
					{...{
						renderQuestion,
						selectedVariants,
						finishTest,
						contentContainerRef,
						type,
						questions
					}}
				/>
			) : (
				questions.map((question, index) => renderQuestion(question, index))
			)}
		</ol>
	) : null;
};

QuestionsList.propTypes = {
	contentContainerRef: PropTypes.object,
	finishTest: PropTypes.func,
	interactiveType: PropTypes.string,
	isSliderLayout: PropTypes.bool,
	isTestCorrect: PropTypes.bool,
	isTestFinished: PropTypes.bool,
	mode: PropTypes.string,
	questions: PropTypes.array,
	selectVariant: PropTypes.func,
	selectedVariants: PropTypes.arrayOf(
		PropTypes.oneOfType([VariantPropType, PropTypes.object])
	),
	type: PropTypes.string
};

export default QuestionsList;
